import React, {Component} from 'react';

class BingoBoard extends Component {
  constructor(props){
    super(props);
    this.state = {
      board: props.board
    }
  }

  static getDerivedStateFromProps(props, state){
    if(props !== state){
      state = props;
    }
    return state;
  }
  
  render(){
    return(
      <div id="board" className="flex">
        {Object.keys(this.state.board).map((letter, i) => {
          return(
            <div key={"board-row-" + letter} className="row no-wrap set-size text-center">
              <div className="col board-letter white-bg">{letter}</div>
              {
                this.state.board[letter].map((number) => {
                  const isUnused = this.props.unusedLetters &&
                    this.props.unusedLetters.includes(letter);
                  const className = isUnused ? "col ball" :
                    number.active ? "col ball active" :
                    number.called ? "col ball called" : "col ball";
                  return(
                    <div key={number.display} className={className}>
                          {number.number}
                    </div>
                  )
                })
              }
            </div>
          )
        })}
      </div>
    )
  }
}
export default BingoBoard;